;(function () {
  'use strict'

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const CLASS_NAME_SHOW$1 = 'show'
  const CLASS_NAME_SHOW$2 = 'active'
  const CLASS_NAME_SHOW$3 = 'down'
  const CLASS_NAME_SHOW$4 = 'up'
  const CLASS_NAME_SHOW$5 = 'overflow-container'
  const CLASS_NAME_SHOW$6 = 'booking__open'
  const CLASS_NAME_SHOW$7 = 'open'

  const SELECTOR_DATA_TOGGLE$1 = '[data-tb-toggle="collapse"]'
  const SELECTOR_DATA_TOGGLE$2 = '[data-tb-toggle="booking"]'
  const SELECTOR_DATA_TOGGLE$3 = '[data-tb-toggle="modal"]'

  const ATTRIBUTE$1 = 'data-tb-target'
  const SELECTOR_ELEMENT$1 = '.header__logo.js-scroll-logo img'
  const SELECTOR_ELEMENT$2 = 'header' // Id of Header main element
  const SELECTOR_ELEMENT$3 = '.js-accordion-title'
  const SELECTOR_ELEMENT$4 = '.hero-full'
  const SELECTOR_ELEMENT$5 = 'body'
  const SELECTOR_ELEMENT$6 = '#header.hero'
  const SELECTOR_ELEMENT$7 = '#hero_mobile'
  const SELECTOR_ELEMENT$8 = '.primary-navigation__mobile > ul > li > a'
  const SELECTOR_ELEMENT$9 = '.sub-sub-menu'
  const SELECTOR_ELEMENT$10 = '.submenu'

  const LOGO_HEADER_WHITE = 'assets/images/the-dorian-logo-header.svg'
  const LOGO_HEADER_VIOLET = 'assets/images/the-dorian-logo-header-violet.svg'

  let VALUE_SCROLL_TOP$1 = 0
  let VALUE_SCROLL_TOP$2 = 80
  let VALUE_WINDOW_WIDTH$1 = 1000

  /**
   * ------------------------------------------------------------------------
   * Functions
   * ------------------------------------------------------------------------
   */

  /**
   * scrollW - Check scroll down or up for header styles
   */
  const scrollW = () => {
    let SCROLL_TOP$1 = window.pageYOffset || document.documentElement.scrollTop
    let HEADER = document.getElementById(SELECTOR_ELEMENT$2)

    if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$2) {
      if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$1) {
        /* Code - Down Scroll */
        onHide(HEADER, CLASS_NAME_SHOW$4)
        onShow(HEADER, CLASS_NAME_SHOW$3)
      } else {
        /* Code - up Scroll */
        onHide(HEADER, CLASS_NAME_SHOW$3)
        onShow(HEADER, CLASS_NAME_SHOW$4)
      }
    } else {
      onHide(HEADER, CLASS_NAME_SHOW$3)
      onHide(HEADER, CLASS_NAME_SHOW$4)
      if(document.querySelector("#gallery-flex")){
        document.querySelector("#header").classList.add('up')
      }
    }

    VALUE_SCROLL_TOP$1 = SCROLL_TOP$1 <= 0 ? 0 : SCROLL_TOP$1
  }

  /**
   * Accordion - Toggle collapse
   */
  const accordion = () => {
    let elements = document.querySelectorAll(SELECTOR_ELEMENT$3)
    let parent, heightCopy, copy

    elements.forEach((element) => {
      element.addEventListener('click', function () {
        parent = this.parentElement
        heightCopy = parent.getElementsByClassName('wrap')[0].clientHeight
        copy = parent.getElementsByClassName('js-accordion-copy')[0]

        if (parent.classList.contains('open')) {
          onHide(parent, 'open')
          copy.style.height = `0`
        } else {
          onShow(parent, 'open')
          copy.style.height = `${heightCopy}px`
        }

        onAriaExpanded(parent)
      })
    })
  }

  /**
   * collapse - Collapse and expand elements
   */
  const collapse = () => {
    let collapse = document.querySelectorAll(`${SELECTOR_DATA_TOGGLE$1}`)

    collapse.forEach((element) => {
      let selector = getSelectorFromElement(element, ATTRIBUTE$1)

      if (selector) {
        let target = document.querySelector(selector)

        element.addEventListener('click', function (event) {
          event.preventDefault()

          onToggle(element, CLASS_NAME_SHOW$2)
          onToggle(target, CLASS_NAME_SHOW$1)
          onAriaExpanded(element)
        })
      }

      return null
    })
  }

  /**
   * modal - Toggle modal
   */
  const modal = () => {
    let modals = document.querySelectorAll(SELECTOR_DATA_TOGGLE$3)

    modals.forEach((element) => {
      let selector = getSelectorFromElement(element, ATTRIBUTE$1)

      if (selector) {
        let target = document.querySelector(selector)

        element.addEventListener('click', function (event) {
          event.preventDefault()

          onToggle(element, CLASS_NAME_SHOW$2)
          onToggle(target, CLASS_NAME_SHOW$7)
        })
      }

      return null
    })
  }

  /**
   * booking - Collapse and expand booking elements
   */
  const booking = () => {
    let text_cta
    const booking = document.querySelectorAll(`${SELECTOR_DATA_TOGGLE$2}`)

    booking.forEach((element) => {
      let selector = getSelectorFromElement(element, ATTRIBUTE$1)

      if (selector) {
        let BODY = document.querySelector(SELECTOR_ELEMENT$5)
        let HEADER = document.querySelector(SELECTOR_ELEMENT$6)
        let IMG_HEADER = document.querySelector(SELECTOR_ELEMENT$1)
        let target = document.querySelector(selector)

        element.addEventListener('click', function (event) {
          event.preventDefault()

          text_cta = element.innerHTML
          if (text_cta.indexOf('Book Now') >= 0) {
            element.innerHTML = text_cta.replace('Book Now', 'Close')
          } else {
            element.innerHTML = text_cta.replace('Close', 'Book Now')
          }

          if (
            HEADER.classList.contains(CLASS_NAME_SHOW$3) ||
            HEADER.classList.contains(CLASS_NAME_SHOW$4)
          ) {
            updatedAttributes(IMG_HEADER, 'src', LOGO_HEADER_VIOLET)
          } else if (
            (!HEADER.classList.contains(CLASS_NAME_SHOW$3) ||
              !HEADER.classList.contains(CLASS_NAME_SHOW$4)) &&
            HEADER.classList.contains(CLASS_NAME_SHOW$6)
          ) {
            updatedAttributes(IMG_HEADER, 'src', LOGO_HEADER_WHITE)
          } else {
            updatedAttributes(IMG_HEADER, 'src', LOGO_HEADER_WHITE)
          }

          onToggle(element, CLASS_NAME_SHOW$1)
          onToggle(target, CLASS_NAME_SHOW$1)
          onToggle(BODY, CLASS_NAME_SHOW$5)
          onToggle(HEADER, CLASS_NAME_SHOW$6)
        })
      }

      return null
    })
  }

  const changeHero = () => {
    let HERO_MOBILE = document.querySelector(SELECTOR_ELEMENT$7)

    if (HERO_MOBILE !== null) {
      let BODY = document.querySelector(SELECTOR_ELEMENT$5)
      let HEADER = document.querySelector(SELECTOR_ELEMENT$6)

      HERO_MOBILE.addEventListener('click', function (event) {
        onToggle(BODY, CLASS_NAME_SHOW$5)
        onToggle(HEADER, CLASS_NAME_SHOW$3)
        onToggle(HEADER, CLASS_NAME_SHOW$4)
      })
    }
  }

  const openMenuMobile = () => {
    let WIDTH_WINDOW = window.innerWidth || screen.width

    if (WIDTH_WINDOW <= VALUE_WINDOW_WIDTH$1) {
      let NAV_MOBILE = document.querySelectorAll(SELECTOR_ELEMENT$8)

      NAV_MOBILE.forEach((item) => {
        item.addEventListener('click', function (event) {
          let PARENT = item.parentElement
          let SUB_MENU =
            PARENT !== null ? PARENT.querySelector(SELECTOR_ELEMENT$9) : null
          let SUB_MENU_ITEM =
            SUB_MENU !== null
              ? SUB_MENU.querySelector(SELECTOR_ELEMENT$10)
              : null
          let HEIGHT =
            SUB_MENU_ITEM !== null ? SUB_MENU_ITEM.clientHeight : null

          if (SUB_MENU !== null && SUB_MENU_ITEM !== null) {
            if (PARENT.classList.contains(CLASS_NAME_SHOW$7)) {
              // Redirection link
            } else {
              event.preventDefault()

              onToggle(PARENT, CLASS_NAME_SHOW$7)
              onToggle(SUB_MENU, CLASS_NAME_SHOW$7)

              if (!PARENT.classList.contains(CLASS_NAME_SHOW$7)) {
                SUB_MENU.style.height = `0`
              } else {
                SUB_MENU.style.height = `${HEIGHT}px`
              }
            }
          }
        })
      })
    }
  }

  /**
   * ------------------------------------------------------------------------
   * DOM Content Loaded is ready available
   * @param {*} callback
   * ------------------------------------------------------------------------
   */
  const onDOMLoaded = (callback) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(callback, 1)
      })
    } else {
      document.addEventListener('DOMContentLoaded', callback)
    }
  }

  onDOMLoaded(
    /**
     * This function add a class to header when scroll down the page
     * and change the logo by a new file if needed depending of mockup
     */
    scrollW(),
    window.addEventListener('scroll', function () {
      scrollW()
    }),
    accordion(),
    collapse(),
    modal(),
    booking(),
    changeHero(),
    openMenuMobile(),
  )
})()

function showGallery() {
  const gallery = document.getElementById("gallery-flex");

  if (gallery) {
    gallery.style.display = "none"; 

    setTimeout(() => {
      gallery.style.display = "block";
      gallery.style.paddingTop = "200px"; 
    }, 1000);
  }
}

showGallery();